module.exports = __webpack_public_path__ + "static/video conferencing-e75293d2e3b303995c7918dec34550a1.png";